import React from "react";
import { CheckCircle2, ArrowRight } from "lucide-react";

const HIGHLIGHTS = [
  "Licensed gas fitters & Red Seal HVAC technicians",
  "20+ years serving residential & commercial",
  "Free in-home assessments and quotes",
  "CleanBC Home Performance Contractor",
];

const About = () => {
  return (
    <section id="about" className="relative py-20 lg:py-28 bg-white" data-testid="about-section">
      <div className="absolute right-0 top-20 w-[400px] h-[400px] cg-halftone opacity-50 pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 grid lg:grid-cols-2 gap-14 items-center">
        {/* Image */}
        <div className="relative" data-testid="about-image">
          <div className="rounded-3xl overflow-hidden shadow-xl">
            <img
              src="/img/services/ac-maintenance.webp"
              alt="Corona Gas technician servicing HVAC equipment"
              className="w-full h-[520px] object-cover"
            />
          </div>
          {/* Stats card */}
          <div className="absolute -bottom-10 -right-4 sm:right-6 bg-[#E50914] text-white rounded-2xl p-6 shadow-2xl max-w-[260px]" data-testid="about-stat">
            <div className="text-5xl font-[Manrope] font-extrabold leading-none mb-1">20+</div>
            <div className="text-sm uppercase tracking-wider opacity-90 font-semibold">
              Years of Trusted Service
            </div>
            <div className="mt-3 text-xs opacity-80">
              Lower Mainland · Vancouver · Surrey · Burnaby
            </div>
          </div>
        </div>

        {/* Content */}
        <div data-testid="about-content">
          <div className="eyebrow mb-4">Who Are We</div>
          <h2 className="font-[Manrope] font-extrabold text-[#0F0F0F] text-3xl sm:text-4xl lg:text-5xl leading-tight mb-6">
            Experienced HVAC Pros in Comfort &amp; Climate Control
          </h2>
          <p className="text-[#475569] text-lg leading-relaxed mb-6">
            Our legacy in the HVAC industry is built on over 20 years of unwavering service in the Lower Mainland. Our local professionals deliver top-of-the-line heating solutions, advanced ventilation technology, and air conditioning systems designed for BC's specific climate and energy efficiency needs.
          </p>
          <p className="text-[#475569] leading-relaxed mb-8">
            Our passion for ensuring comfort and satisfaction in every home and business is matched only by our commitment to the exceptional quality that has become our trademark.
          </p>

          <ul className="grid sm:grid-cols-2 gap-3 mb-8">
            {HIGHLIGHTS.map((h) => (
              <li key={h} className="flex items-start gap-3" data-testid="about-highlight">
                <CheckCircle2 className="w-5 h-5 text-[#E50914] mt-0.5 flex-shrink-0" />
                <span className="text-[#0F0F0F] font-medium">{h}</span>
              </li>
            ))}
          </ul>

          <a href="#contact" className="btn-coral" data-testid="about-cta">
            Talk to Our Team
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
